import { MEMBER_AGE_CATEGORIES } from "../constants";
import { IconName } from "@fortawesome/fontawesome-svg-core";

const memberIcons: { [K in keyof typeof MEMBER_AGE_CATEGORIES]?: IconName } = {
  [MEMBER_AGE_CATEGORIES.BABY]: 'baby',
  [MEMBER_AGE_CATEGORIES.CHILD]: 'child-reaching',
  [MEMBER_AGE_CATEGORIES.ADULT]: 'user'
}

export default memberIcons